module.exports = __webpack_public_path__ + "img/feedback_outlined.13bb38b6.svg";